import React from 'react';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { requiredValidation, withFormEventValidation } from '../../validatableComponent';
import { FormTextarea } from '../../FormTextarea';
import { actions as metaDataActions, GetStarted } from '../redux';

const NameFormInput = withFormEventValidation(FormInput, requiredValidation);

type Actions = typeof metaDataActions;
type Props = GetStarted & {
  getStartedUpdate: Actions['getStartedUpdate'];
  fieldDisabled: (field: string) => boolean;
};

export const MetaDataConfigurationGetStarted: React.FC<Props> = ({
  category,
  externalId,
  fieldDisabled,
  getStartedUpdate,
  name,
  offerDescription,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    getStartedUpdate(event.currentTarget.id, event.currentTarget.value);
  };

  return (
    <>
      <NameFormInput
        id='name'
        label='Name'
        onChange={handleChange}
        readonly={fieldDisabled('name')}
        type='text'
        value={name}
        required={true}
      />
      <FormInput
        id='category'
        label='Category'
        onChange={handleChange}
        readonly={fieldDisabled('category')}
        type='text'
        value={category}
      />
      <FormInput
        id='externalId'
        label='External ID'
        onChange={handleChange}
        readonly={fieldDisabled('externalId')}
        type='text'
        value={externalId}
      />
      <FormTextarea
        label='Offer Description'
        id='offerDescription'
        onChange={handleChange}
        readonly={fieldDisabled('offerDescription')}
        value={offerDescription}
        rows='5'
        maxLength={1024}
      />
    </>
  );
};
